module.exports = __webpack_public_path__ + "static/shapya-shopping-ce6cc479e8b7cb17f3ac7c395eb0bd5a.png";